var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 29.229,
    viewBox: "0 0 26 29.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 26,
    height: 29.229,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 11.856,
    height: 11.92,
    fill: "#8ebe78",
    stroke: "#8ebe78",
    strokeWidth: 0.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M26,20.64V8.589a2.564,2.564,0,0,0-1.282-2.22L14.282.344a2.564,2.564,0,0,0-2.564,0L1.282,6.369A2.564,2.564,0,0,0,0,8.589V20.64a2.564,2.564,0,0,0,1.282,2.22l10.436,6.025a2.564,2.564,0,0,0,2.564,0L24.718,22.86A2.564,2.564,0,0,0,26,20.64",
    transform: "translate(0 0)",
    fill: "#8ebe78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M27.88,24.017V14.379a2.564,2.564,0,0,0-1.282-2.22L18.252,7.34a2.566,2.566,0,0,0-2.564,0L7.342,12.159a2.564,2.564,0,0,0-1.282,2.22v9.637a2.564,2.564,0,0,0,1.282,2.22l8.346,4.819a2.564,2.564,0,0,0,2.564,0L26.6,26.237a2.564,2.564,0,0,0,1.282-2.22",
    transform: "translate(-3.97 -4.583)",
    fill: "#d3fac0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(7.072 9.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M152.988,377.76c-.115-.033-.237-.046-.351-.084a1.79,1.79,0,0,1-1.153-1.181.106.106,0,0,0-.12-.076c-.46,0-.921.005-1.381,0a.122.122,0,0,0-.129.087,3.06,3.06,0,0,1-.138.334,1.817,1.817,0,0,1-1.256.891c-.243.056-.325.126-.311.371.025.432.017.862,0,1.294a.265.265,0,0,0,.214.253.967.967,0,0,0,.318.007c.683,0,1.366,0,2.049,0h1.888a2.3,2.3,0,0,0,.356-.011.2.2,0,0,0,.187-.169,1.366,1.366,0,0,0,.026-.26c0-.4,0-.79,0-1.186a.243.243,0,0,0-.2-.273m-1.124,1.194c-.8.006-1.593,0-2.39,0a1.039,1.039,0,0,1-.249-.021.08.08,0,0,1-.071-.061.792.792,0,0,1-.006-.35c.01-.06.077-.073.128-.071.26.008,1.931-.029,2.379-.017.129,0,.259.011.389.014a.139.139,0,0,1,.155.16c-.005.312.055.341-.335.344",
    transform: "translate(-144.735 -367.749)",
    fill: "#8ebe78",
    stroke: "#8ebe78",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M371.641,38.8a.98.98,0,0,0-.268-.6,1.946,1.946,0,0,0-1.353-.485c-.054,0-.061.029-.061.073a3.394,3.394,0,0,1-.044.521c-.009.058-.009.116.079.121a2.506,2.506,0,0,1,.62.116.467.467,0,0,1,.341.432,1.523,1.523,0,0,1-.287.892,5.806,5.806,0,0,1-1.333,1.37.991.991,0,0,0-.3.269,8.362,8.362,0,0,1-.662,1.085l-.085.113a.554.554,0,0,0,.228-.074,6.8,6.8,0,0,0,.88-.544,9.011,9.011,0,0,0,.975-.766,5,5,0,0,0,.737-.827,2.367,2.367,0,0,0,.538-1.7",
    transform: "translate(-359.801 -36.85)",
    fill: "#8ebe78",
    stroke: "#8ebe78",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M2.75,41.385a.87.87,0,0,0-.3-.364c-.264-.217-.526-.437-.783-.663a3.441,3.441,0,0,1-.454-.5,2.159,2.159,0,0,1-.489-.934c-.057-.343,0-.6.427-.71.161-.04.323-.066.487-.089.065-.009.127-.024.11-.117a3.425,3.425,0,0,1-.046-.475c0-.08-.03-.119-.129-.125a1.837,1.837,0,0,0-.822.176,1.147,1.147,0,0,0-.75,1.022A1.951,1.951,0,0,0,.247,39.67a4.54,4.54,0,0,0,.785,1.059,8,8,0,0,0,.993.857,7.816,7.816,0,0,0,1.168.737c.043.021.082.059.139.034a.354.354,0,0,0-.078-.135,4.5,4.5,0,0,1-.5-.836",
    transform: "translate(0 -36.544)",
    fill: "#8ebe78",
    stroke: "#8ebe78",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M103.149,1.048c.044.317.1.632.155.948a9.933,9.933,0,0,0,.41,1.613,6.85,6.85,0,0,0,.785,1.546c.142.206.572.857.632.941.022.04.173.251.231.34a2.951,2.951,0,0,1,.574,1.5c.018.048.046.063.089.027.422,0,.843-.005,1.265,0,.1,0,.143-.016.143-.13a1.178,1.178,0,0,1,.056-.333,4.065,4.065,0,0,1,.518-1.055c.031-.033.478-.707.509-.751a9.9,9.9,0,0,0,.973-1.7,6.018,6.018,0,0,0,.331-.923c.125-.5.223-1.013.311-1.525a6.465,6.465,0,0,0,.107-1.3.214.214,0,0,0-.166-.207A1.039,1.039,0,0,0,109.723,0c-.192.006-.383.011-.575.012q-2.032,0-4.063,0c-.257,0-.513.006-.77-.009a6.079,6.079,0,0,0-1,.035.181.181,0,0,0-.174.164c-.009.052-.015.1-.019.156,0,0,0,.3,0,.3.008.129.008.259.025.386m2.371,4.774h0",
    transform: "translate(-100.749 0)",
    fill: "#8ebe78",
    stroke: "#8ebe78",
    strokeWidth: 0.25
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopActive);
export default __webpack_public_path__ + "static/media/top-active.60c3f6bbce2439b9b3087e62ff62091c.svg";
export { ForwardRef as ReactComponent };